import React from 'react'
// libs
import { Checkbox, FormControlLabel } from '@mui/material'
// components
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// hooks
import { useSnackbar } from 'notistack'
// types
import { IApiClientCreatedCredentials } from 'types/graphql'
// views
import { Actions, CopyIconButton, Field, Label, Value, ValueRow, Warning, Wrapper } from './views'

interface Props {
  credentials: IApiClientCreatedCredentials
  onDone: () => void
}

const CredentialsView: React.FC<Props> = ({ credentials, onDone }) => {
  const { enqueueSnackbar } = useSnackbar()

  const [confirmed, setConfirmed] = React.useState(false)

  const onConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmed(event.target.checked)
  }

  const copy = (value: string) => () => {
    navigator.clipboard.writeText(value)
    enqueueSnackbar('Copied!', { variant: 'success', autoHideDuration: 1000 })
  }

  return (
    <Wrapper>
      <Warning>Copy this secret now. It won&apos;t be shown again</Warning>

      <Field>
        <Label>Client ID</Label>
        <ValueRow>
          <Value>{credentials.clientId}</Value>
          <CopyIconButton type='button' onClick={copy(credentials.clientId)} title='Copy Client ID'>
            <ContentCopyIcon />
          </CopyIconButton>
        </ValueRow>
      </Field>

      <Field>
        <Label>Client Secret</Label>
        <ValueRow>
          <Value>{credentials.secret}</Value>
          <CopyIconButton type='button' onClick={copy(credentials.secret)} title='Copy Client Secret'>
            <ContentCopyIcon />
          </CopyIconButton>
        </ValueRow>
      </Field>

      <FormControlLabel
        control={<Checkbox checked={confirmed} onChange={onConfirmChange} />}
        label='I have copied and stored the Client ID and Secret in a safe place'
        sx={{ marginLeft: '-12px' }}
      />

      <Actions>
        <Button layout={BUTTON_LAYOUTS.PURPLE} disabled={!confirmed} onClick={onDone}>
          Done
        </Button>
      </Actions>
    </Wrapper>
  )
}

export default CredentialsView
